module.exports = __webpack_public_path__ + "static/media/1.fe142ea6.jpg";